import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  counter: number
  className: string
}

export const CommentCounter: React.FC<Props> = ({ counter, className }) => (
  <div className={clsJoin(className, css.comment_counter)}>{counter}</div>
)
